import {useTranslation} from "react-i18next";

export function useTranslate(prefix?: string) {
  return useTranslation(undefined, { keyPrefix: prefix });
}